// extracted by mini-css-extract-plugin
export default {"button":"ExtendedButton_button__H4R2S"};